<template>
  <div :class="classModifier">
    <div :class="menuClassModifier">
      <div class="market-filters-desktop-grid__menu-filters">
        <menu-button
          @click="toggleFilters"
          theme="sushi-pill"
          type="filters"
          :name="filterMenuName"
          :active="filtersOpen"
          :filtersSelected="selectedFilters.length > 0"
        ></menu-button>
      </div>
      <div v-if="shouldShowTimespanFilter" class="market-filters-desktop-grid__menu-timespan">
        <menu-button
          @click="toggleTimespans"
          type="timespan"
          theme="sushi-pill"
          :name="selectedTimespan.name"
          :active="timespansOpen"
        ></menu-button>
      </div>
      <div class="market-filters-desktop-grid__menu-order">
        <menu-button
          @click="toggleOrder"
          theme="sushi-pill"
          :type="selectedOrder.sort"
          :name="orderMenuName"
          :active="ordersOpen"
        ></menu-button>
      </div>
      <div class="market-filters-desktop-grid__menu-title">Sort By:</div>
    </div>
    <transition name="slide-down">
      <div
        class="market-filters-desktop-grid__order"
        v-click-outside="closeFilters"
        v-if="ordersOpen"
      >
        <menu-button
          v-for="order in orderList('markets')"
          :theme="theme"
          :key="order.sort"
          :type="order.sort"
          :name="order.fullName"
          :selected="orderSelected(order.sort)"
          @click="selectOrderAndClose"
        ></menu-button>
      </div>
    </transition>
    <transition name="slide-down">
      <div
        class="market-filters-desktop-grid__filters"
        v-click-outside="closeFilters"
        v-if="filtersOpen"
      >
        <a class="market-filters-desktop-grid__clear-all" @click.prevent="onClearFilters"
          >Clear Selections</a
        >
        <div class="market-filters-desktop-grid__filters-group" v-for="category in filters">
          <h3>{{ category.name }}</h3>
          <filter-button
            v-for="filter in category.filters"
            :theme="theme"
            :key="filterKey(filter)"
            :id="filter.filterId"
            :name="filter.name"
            :selected="filterSelected(filter.filterId)"
            @addFilter="onAddFilter"
            @removeFilter="onRemoveFilter"
          ></filter-button>
        </div>
      </div>
    </transition>
    <transition name="slide-down">
      <div
        class="market-filters-desktop-grid__timespans"
        v-click-outside="closeFilters"
        v-if="timespansOpen"
      >
        <menu-button
          v-for="timespan in availableTimespanOptions"
          :theme="theme"
          :key="timespan.parameter"
          :type="timespan.parameter"
          :name="timespan.name"
          @click="selectTimespanAndClose"
        ></menu-button>
      </div>
    </transition>
  </div>
</template>

<script src="./market-filters-desktop-grid.js"></script>
<style src="./market-filters-desktop-grid.scss" lang="scss"></style>
